import React from "react";
import ColorLink from "./color_link";
import FontLink from "./font_link";
import PropTypes from "prop-types";

const AssetLinks = ({asset} = props) => {
  if (asset.type === "fonts") {
    return (
      <li className="s-download-computer s-asset-action-item s-org-button">
        <FontLink asset={asset} />
      </li>
    );
  } else if (asset.type === "colors") {
    return (
      <li className="s-download-computer s-asset-action-item s-org-button s-org-button-color">
        <ColorLink asset={asset} />
      </li>
    );
  } else if (asset.type !== "texts") {
    return (
      <li className="s-download-computer s-asset-action-item s-org-button">
        <a href={asset.attributes.asset_data.url} target="_blank">
          <button className="noline button primary">
            <span className="bff-visit-media" />
            {t('Visit Media')}
          </button>
        </a>
      </li>
    );
  }
};

AssetLinks.propTypes = {
  asset: PropTypes.object.isRequired
};

export default AssetLinks;
